import { makeRequest } from 'utils/requestLogger';

export default (id, assessments) =>
  makeRequest('put', `/api/submissions/${id}/assessments`, assessments);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/submission/saveAssessment.js